




























import Vue from "vue";
import moment from "moment";

import { GetNotificationCommand } from "@/model/communication/notification/GetNotificationCommand";
import { GetNotificationsReqData } from "@/model/communication/notification/GetNotificationsReqData";
import { GetNotificationsResData } from "@/model/communication/notification/GetNotificationsResData";
import { UpdateResultNotification } from "@/model/data/notifications/UpdateResultNotification";
import { NotificationTypesEnum } from "@/model/data/enums/NotificationTypesEnum";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    data() {
        return {
            loading: false,
            updateNotification: new Array<UpdateResultNotification>(),
            headers: [
                { text: this.$t("common.timestamp"), value: "timestamp" },
                {
                    text: this.$t("common.file_name"),
                    value: "filename",
                },
                {
                    text: this.$t("notifications.result_code.lbl"),
                    value: "resultCode",
                    align: "center",
                },
            ],
        };
    },
    props: {
        installationName: {
            type: String,
            required: true,
        },
    },
    methods: {
        async fetchNotifications() {
            this.loading = true;

            const reqData = new GetNotificationsReqData();
            reqData.device = this.installationName;
            reqData.orderBy = ["Timestamp"];
            reqData.orderByDescending = [true];

            var resData: GetNotificationsResData = await new GetNotificationCommand(reqData).execute();

            if (resData.responseStatus == ApiResponseStatusEnum.Success) {
                this.updateNotification.splice(0, this.updateNotification.length);
                resData.notifications.forEach((notification) => {
                    if (notification.notificationType == NotificationTypesEnum.Update) this.updateNotification.push(notification as UpdateResultNotification);
                });
            }
            this.loading = false;
        },
        localeTimeFromUtc: function (UtcDate) {
            return moment.utc(UtcDate).format();
        },
    },
    async mounted() {
        this.fetchNotifications();
    },
});
